








import Vue from "vue";

export default Vue.extend({
  name: "NavigationButtonFooter",
  props: ["routeLink", "routeName"],
  methods: {
    routeChangeEmit() {
      this.$emit("clicked");
    }
  }
});
